import HighlightedText from './HighlightedText'

export default HighlightedText
